import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WidgetService {
  apiBaseURL!: string;
  constructor(
    environmentService: EnvironmentService,
    private readonly http: HttpClient
  ) {
    this.apiBaseURL = environmentService.getApiEndpoint();
  }

  // getAllWidgetList(params: any = {}): Observable<any> {
  //   let options = {
  //     params: new HttpParams({ fromObject: params }),
  //   };
  //   return this.http.get<any>(`${this.apiBaseURL}widgets`, options);
  // }

  getAllWidgetList(params: any = {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(
      `${this.apiBaseURL}widgets/getAllWithPagination`,
      options
    );
  }

  getAllCreatedWidgetList(params: any = {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(
      `${this.apiBaseURL}widgets/created-widgets/getAllWithPagination`,
      options
    );
  }

  getAllWidgetUserGroupList(user_group: any): Observable<any> {
    const params = new HttpParams().set('user_group', user_group);
    return this.http.get<any>(`${this.apiBaseURL}widgets`, { params });
  }

  getFullWidgetList(params: any = {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(`${this.apiBaseURL}widgets`, options);
  }

  getWidget(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiBaseURL}widgets/${id}`);
  }

  saveWidget(payload: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseURL}widgets/widget-alignment`,
      payload
    );
  }
  getAlignedWidgetList(employee_id: string): Observable<any> {
    // console.log("empid",employee_id);
    const params = new HttpParams().set('employee_id', employee_id);
    return this.http.get<any>(`${this.apiBaseURL}widgets/widget-alignment`, {
      params,
    });
  }
  getAllCustomWidgetList(): Observable<any> {
    return this.http.get<any>(`${this.apiBaseURL}custom`);
  }

  saveCustomWidget(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBaseURL}custom`, payload);
  }
  updateCustomWidget(payload: any, id: any): Observable<any> {
    return this.http.put<any>(`${this.apiBaseURL}custom/${id}`, payload);
  }
  editWidget(payload: any, id: any): Observable<any> {
    return this.http.put<any>(`${this.apiBaseURL}widgets/${id}`, payload);
  }

  editWidgetList(payload: any, id: any): Observable<any> {
    return this.http.put<any>(`${this.apiBaseURL}widgets/edit-widget/${id}`, payload);
  }

  createWidget(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBaseURL}widgets`, payload);
  }

  createWidgetList(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBaseURL}widgets/create-widget`, payload);
  }

  // Colorpallette-------
  add(formData: any): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'color', formData);
  }

  update(formData: any, id: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'color/' + id, formData);
  }

  getColor(id: any): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'color/' + id);
  }

  // getLeavebalance(params: { emp_id: any; company_id: any }): Observable<any> {
  //   return this.http.get<any>(`${this.apiBaseURL}leave-req/balance?`, {
  //     params,
  //   });
  // }

  getLeavebalanceToEncash(params: { param: any }): Observable<any> {
    return this.http.get<any>(`${this.apiBaseURL}leave-req/balance?`, {
      params,
    });
    // getLeavebalance(params: { emp_id: any, company_id: any }): Observable<any> {
    //   return this.http.get<any>(`${this.apiBaseURL}leave-req/balance?`, { params });
  }

  getLeavebalance(payload: any): Observable<any> {
    let params = new HttpParams()
      .set('year', payload.year)
      .set('emp_id', payload.emp_id)
      .set('company_id', payload.company_id);

    if (Array.isArray(payload.leave_type_ids)) {
      params = params.set('leave_type_ids', payload.leave_type_ids.join(','));
    }
    return this.http.get<any>(`${this.apiBaseURL}leave-req/balance?`, {
      params,
    });
  }

  deleteWidgget(id: any): Observable<any> {
    return this.http.delete<any>(this.apiBaseURL + 'widgets/' + id);
  }
}
